@if (layout.isLoading) {
<app-fullscreen-loading />
}

<div class="wrapper">
  @if (layout.sidenavSize === 'offcanvas') {
  <app-topbar />
  }

  <app-sidenav />

  <div class="content-page">
    <router-outlet (activate)="onRouteActivated()" />

    <!-- <app-footer /> -->
  </div>
</div>
